import loadable from '@loadable/component';

export const QuillWrapperLoadable = loadable(() => import('./QuillWrapper'), {
  resolveComponent: (module) => module.QuillWrapper,
  ssr: false,
});
